import { Box, styled, Link } from '@mui/material';
import { LinkProps } from 'react-router-dom';

export const BreadcrumbsBox = styled(Box)`
  border: 1px solid #dedede80;
  padding: 4px 8px;
  border-radius: 5px;
  width: fit-content;
  cursor: pointer;
`;
export const LinkStyled = styled(Link)<LinkProps>`
  display: flex;
  text-transform: capitalize;
`;
